<!-- 修改手机号码 -->
<template>
    <div class="edit white">
      <el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="700px" :before-close="handleChangeDrawer" :close-on-click-modal="false">
          <div class="pay-mains">
            <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
              <el-row>
                <el-col :span="12">
                    <el-form-item
                        class="el-form-item-update"
                        ref="mobile"
                        label="手机号码："
                        prop="mobile"
                        :rules="$rules.required"
                        >
                        <el-input v-model="form.mobile" placeholder="请输入手机号码" maxlength="11"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                    class="el-form-item-update"
                    ref="verifyCode"
                    label="验证码："
                    prop="verifyCode"
                    :rules="$rules.required"
                    >
                    <div class="flex-row">
                        <el-input placeholder="输入验证码" v-model="form.verifyCode" maxlength="6">
                        <span slot="suffix" class="cur jishi" @click="addLoginCode">{{ codeName ? '获取验证码':time+'s'}}</span>
                        </el-input>
                    </div>
                    </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="btns">
              <el-button type="primary" @click="save">确定</el-button>
            </div>
          </div>
      </el-dialog>
    </div>
  </template>

  <script>
    import minxin from "../../../assets/javascript/minxin.js";
    import { decrypt, encrypt } from "../../../assets/javascript/untils";
  export default {
    data () {
      return {
        codeName: true,
        time: 60,
        addEditShow: false,
        addEditTitle: "",
        form: {
          mobile: '',
          verifyCode: ''
        }
      };
    },
    mixins: [minxin],
    components: {
      
    },
    computed: {},
    created() {
      this.init();
    },
    methods: {
        addLoginCode() {
        if (this.form.mobile == "") {
            this.$message.error("请输入手机号码");
            return false;
        }
        if (this.form.mobile.length != 11) {
            this.$message.error("请输入正确的手机号码");
            return false;
        }
        let arr = encrypt(
            JSON.stringify({
            mobile: this.form.mobile,
            bizType: 'changeMobile',
            bizSource: 'staffChangeMobile',
            millisecond: new Date().getTime()
            })
        );
        this.$api.post(this.$url.send, arr).then(resp => {
            if (resp) {
                this.codeName = false;
                this.$message.success("短信发送成功")
            } else {
                this.codeName = true;
                clearInterval(auth_timetimer);
            }
            this.time = 60;
        });
        let auth_timetimer = setInterval(() => {
            if (this.time <= 0) {
                this.time = 60;
                this.codeName = true;
                clearInterval(auth_timetimer);
            }
            this.time--;
        }, 1000);
        },
      //  页面初始化函数
      init() {
        this.$on("set", function(item) {
          Object.assign(this.$data, this.$options.data());
          this.addEditShow = true;
          this.addEditTitle = "修改手机号码";
        });
      },
      handleChangeDrawer(val) {
        this.addEditShow = false;
      },
      // 保存
      save () {
        if (!this.form.mobile) {
          this.$message.error('请输入手机号');
          return false;
        }
        if (this.form.mobile.length != 11) {
          this.$message.error('请输入正确的手机号码');
          return false;
        }
        if (!this.form.verifyCode) {
          this.$message.error('请输入验证码');
          return false;
        }
        this.addEditShow = false;
        sessionStorage.setItem("mobileChange", JSON.stringify({
          mobile: this.form.mobile,
          verifyCode: this.form.verifyCode
        }))
        this.$emit("change", true);
      }
    }
  };
  </script>
  <style scoped lang="less">
  @import "../../../assets/css/edit.less";
  .pay-mains {
    padding: 0;
    height: 100%;
    /deep/ .el-form-item__content {
        width: 250px !important;
    }
    /deep/ .el-input__suffix {
      right: 10px;
      
  
    }
    .elButton {
      height: 30px;
    }
    /deep/ .el-form {
      padding-bottom: 20px;
      /deep/ .el-form-item {
        background: #fff;
      //   border-bottom: 1px solid @borderColor;
        padding: 10px 0;
        // margin-bottom: 0;
        &:last-child {
          border-bottom: 0;
        }
        
      }
      
    }
  }
  </style>